import React, { lazy, Suspense } from 'react';

const LazyLoginComponent = lazy(() => import('./dashboard.component'));

const DashboardComponent = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyLoginComponent {...props} />
  </Suspense>
);

export default DashboardComponent;
